import {
  Component,
  OnInit,
  Input,
  ViewChild,
  QueryList, ViewChildren
} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';
import {GMapService} from "../../services/g-map.service";
import {Pos} from "../../model/PosModel";
import {Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {catchError, map, share, tap} from 'rxjs/operators';
import { MapInfoWindow, MapMarker, GoogleMap } from '@angular/google-maps';
@ComponentAsElement('v-map-holder-element')
@Component({
  selector: 'v-map-holder-element',
  templateUrl: './map-holder.component.html',
  styleUrls: []
})
export class MapHolderComponent implements OnInit {
  latitude = 50.9189;
  longitude = 19.1344;
  zoom = 6;
  center = {lat: 51.9189, lng: 19.1344};
  markerClustererImagePath =
    'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  options = {
    styles: [
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "lightness": "0"
          },
          {
            "saturation": "-96"
          }
        ]
      },
      {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          },
          {
            "lightness": "100"
          },
          {
            "gamma": "0.00"
          },
          {
            "weight": "0.01"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "-5"
          },
          {
            "visibility": "simplified"
          },
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
          {
            "lightness": "54"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "lightness": "100"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      }
    ]
  }
  @Input() markerIcon: string = '_ui/responsive/common/angular/assets/images/map-marker-icon.png';

  poses$: Observable<Pos[]>;
  //geocoder: google.maps.Geocoder;
  gmap;
  geolocationDeny = false;
  firstTrigger = true;
  mapLoading = true;
  apiLoaded: Observable<boolean>;
  @ViewChildren(MapInfoWindow) infoWindowsView: QueryList<MapInfoWindow>;
  lastOpen = null;
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

  constructor(
    private gMapService: GMapService, private httpClient: HttpClient) {
    const apiKey = (document.querySelector('v-map-holder-element') as HTMLElement).dataset.apiKey;
    this.apiLoaded = httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry`, 'callback')
      .pipe(
        map(() => true),
        share(),
        tap(() => {
            this.mapLoading = false;
          return true;
        }),
        catchError(err => {
            console.error(err);
            return of(false);
        })
      );
  }

  ngOnInit() {
    this.poses$ = this.gMapService.poses;
    this.gMapService.currentCity.subscribe(_city => {
      _city && this.apiLoaded && this.setCityLocation(_city);
    });
    this.gMapService.geoRunner.subscribe((_geo) => _geo && this.setCurrentLocation());
  }

  openInfoWindow(marker: MapMarker, windowIndex: number) {
    this.infoWindowsView.forEach((window: MapInfoWindow, index) => {
      if (windowIndex === index) {
        window.open(marker);
        this.lastOpen = window;
      }
      else {
        window.close();
      }
    });
  }

  zoomChanged() {
    this.mapLoading = false;
  }

  private setCityLocation(_newCity) {
    const newCity = _newCity;
    let geocoder = this.apiLoaded ? new google.maps.Geocoder() : null;

    if(geocoder) {
      geocoder.geocode( { address: `${newCity}, PL` }, (results, status) => {
        if(status === google.maps.GeocoderStatus.OK) {
          this.zoom = 12;
          this.center = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
        }
      });
    }
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          this.zoom = 13;
          this.center = {
            lat,
            lng
          };
          if(this.firstTrigger) {
            this.firstTrigger = false;
            this.mapLoading = true;
          }
          this.gMapService.setCurrentLatlong(lat, lng);
        }, (error) => {
          if(error.code === 1)  {
            this.gMapService.runGeo(false);
          }
        }
      );
    }
  }
}
